import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';

@Injectable()
export class LocalStorageService {
	get isAdmin() {
		return ['admin', 'secretary'].includes(this.getItem('role'));
	}

	get isAdminRole() {
		return this.getItem('role') === 'admin';
	}

	get isSecretary() {
		return this.getItem('role') === 'secretary';
	}

	saveItem(key: string, value: string): void {
		const baseKey = CryptoJS.SHA256(key).toString();
		const baseValue = CryptoJS.AES.encrypt(
			value,
			environment.localSecret,
		).toString();

		localStorage.setItem(baseKey, baseValue);
	}

	getItem(key: string, defaultValue: string = ''): string {
		const baseKey = CryptoJS.SHA256(key).toString();
		const value = localStorage.getItem(baseKey);
		if (value) {
			const bytes = CryptoJS.AES.decrypt(value, environment.localSecret);
			return bytes.toString(CryptoJS.enc.Utf8);
		}

		return defaultValue;
	}

	clear() {
		//localStorage.clear();
		[
			'tokenSegVial',
			'bearer',
			'refresh',
			'role',
			'name',
			'userId',
			'identifier',
			'institutionId',
			'permissions',
			'subroles',
			'tokenValleLab',
			'refreshTokenValleLab',
			'isHviPermissions',
		].forEach((item) => {
			let key = CryptoJS.SHA256(item).toString();
			localStorage.removeItem(key);
		});
		localStorage.removeItem('tokenValleLab');
		localStorage.removeItem('aspectComments');
	}
}
